<template>
  <div>
    <div :id="uuid" :style="{width: width+'px',height:height+'px',lineHeight:'20px'}"/>
    <div style="width: 100%;text-align: center;position: absolute;top: 50%;transform: translateY(-50%)"
         :style="{fontSize:option.attribute.numSize+'px', color: numColor}">
      {{progressFormat}}
    </div>
  </div>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import {compareByOperator} from "@/utils/threshold-compare";
import {onMounted, ref, watch,computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag);
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let numColor = props.option.attribute.numColor
let progress = 0
let progressFormat = ref('')
let newData = null;
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras){
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras){
  getDataJson(cptDataForm,paras,(res)=> {
      newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
      jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
      processData(cptDataForm,newData,jsFunFlag)
        // cptData = res;
        loadChart(props.option.attribute);
      })
}
function processData(cptDataForm,res,jsFunFlag) {
      // 第一层判断 如果选择数据集
    if(cptDataForm.dataSource == '4') {
      // 第二层判断 ，如果没有配转换脚本
      if(jsFunFlag) { // 没有全部配置映射字段
          if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
          const dataKey = props.option.attribute.cptTableData;
        // 创建一个新的数组用于存储结果
          let newres = [];
          let newObj = {...res[0]};
        // 如果dataKey中的value有值并且在newObj对象中有对应的值
          // if (dataKey[0].value && newObj[dataKey[0].value]) {
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
          // }
          newres.push(newObj);
          // console.log(newres,'新数组');
          cptData = newres[0]; 
        }
        } else { // 如果配置了转换脚本
          cptData = res;
        }
    } else { // 不是数据集类型，是静态数据
      cptData = res;
    } 

}

function loadChart(attribute) {
  let textColor = attribute.titleColor;
  let progressColor = attribute.progressColor;
  numColor = attribute.numColor;
  if(attribute.alarmConfig && attribute.alarmConfig.threshold){//告警判断
    const res = compareByOperator(attribute.alarmConfig.operator,cptData.value,attribute.alarmConfig.threshold)
    if(res){
      textColor = attribute.alarmConfig.color
      progressColor = attribute.alarmConfig.color
      numColor = attribute.alarmConfig.color
    }
  }

  progress = cptData.value > 100 ? 100 : cptData.value.toFixed(2);
  progressFormat.value = props.option.attribute.format.replace(/{value}/g,progress)

  chartOption = {
    color:[progressColor,attribute.progressBg],
    title: {
      text: attribute.title,
      left: 'center',
      top: attribute.titleOffsetTop + '%',
      // top: '75%',
      // top:'bottom',
      // offsetCenter: [0, attribute.titleOffsetTop + '%'],
      textStyle: {
        fontSize: attribute.titleSize,
        color: textColor
      },
    },
    grid: {
      y:20,y2:90,
    },
    series: [
      {
        name: attribute.title,
        type: 'pie',
        radius: [attribute.progressWidth+'%', '90%'],
        roseType: attribute.roseType==='false' ? false:attribute.roseType,
        label: {
          show: false,
        },
        labelLine: {
          show: false
        },
        itemStyle: {
          borderRadius: attribute.borderRadius,
          borderColor: attribute.borderColor,
          borderWidth: 2
        },
        data: [
          { value: progress},
          { value: 100 - progress},
        ]
      }
    ]
  }
  if(attribute.innerRingShow){
    chartOption.series.push({
      name: attribute.title,
      type: 'pie',
      radius: [attribute.progressWidth-22+'%', attribute.progressWidth-4+'%'],
      label: {show: false},
      labelLine: {show: false},
      itemStyle: {
        borderRadius: attribute.borderRadius,
        borderColor: attribute.borderColor+'40',
        borderWidth: 2
      },
      data: [
        { value: progress,itemStyle: {color: progressColor+'20'}},
        { value: 100 - progress,itemStyle: {color: progressColor+'20'}},
      ]
    })
  }
  chart.setOption(chartOption,true);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
